module.exports = __webpack_public_path__ + "img/user1.733d4c12.jpg";